export default class PagedResult<T> {
  public totalCount!: number;
  public data!: T[];
  constructor() {
    this.totalCount = 0;
    this.data = [];
  }
}
